<fieldset [formGroup]="datePerformedGroup" *ngIf="visible$ | async">
    <ng-container *ngrxLet="datePerformed$; let datePerformed">
        <ng-container *ngIf="datePerformed.choices">
            <div class="row">
                <p class="col-12 col-sm-10" [innerHTML]="datePerformed.description"></p>
                <span class="text-end col-sm-2 col-12 filter-text">{{ elementTypeLabel$ | async }}</span>
            </div>
            <pace-forms-choices
                [choices]="datePerformed.choices"
                *ngIf="datePerformed.choices && !datePerformed.function"
                [formControl]="radioControl"
            ></pace-forms-choices>
        </ng-container>
        <div class="row mb-3">
            <label class="text-start col-12 col-form-label" for="{{ datePerformed.id }}">{{
                datePerformed.dateLabel
            }}</label>
            <div class="col-sm-auto col-9">
                <div class="input-group">
                    <input
                        type="date"
                        class="form-control input-group-sm date-input"
                        [ngClass]="{ 'date-input-not-ok': datePerformed.choices?.choiceNegative?.selected }"
                        id="{{ datePerformed.id }}"
                        #dateInput
                        [formControl]="dateInputControl"
                    />
                    <div class="input-group-append">
                        <span class="input-group-text" (click)="dateInput.focus()"
                            ><fa-icon [icon]="faCalendar"></fa-icon
                        ></span>
                    </div>
                </div>
            </div>
            <div class="col-3 text-sm-start text-end pe-0">
                <button
                    class="btn btn-link"
                    *ngIf="(readOnly$ | async) === false && !dateInput.disabled"
                    (click)="setToday()"
                    translate="F4M_DATE_PERFORMED_SET_TODAY_BUTTON_LABEL"
                ></button>
            </div>
            <div class="col-auto pt-sm-0 pt-4" *ngIf="showNotApplicableCheckbox$ | async">
                <div>
                    <div class="not-applicable">
                        <div class="checkbox-container">
                            <input
                                type="checkbox"
                                class="form-control"
                                id="{{ datePerformed.id }}-not-applicable"
                                [formControl]="checkboxControl"
                            />
                            <label for="{{ datePerformed.id }}-not-applicable"
                                ><fa-icon *ngIf="checkboxControl.value" [icon]="faCheck" size="2x"></fa-icon
                            ></label>
                        </div>
                        <label translate="F4M_NOT_APPLICABLE_LABEL" for="{{ datePerformed.id }}-not-applicable"></label>
                    </div>
                </div>
            </div>
            @if (displayHistoryButton$ | async) {
                <div class="col-auto pt-sm-0 pt-4 ms-auto d-flex align-items-center">
                    <pace-forms-history-button [uniqueId]="datePerformed.uniqueId"></pace-forms-history-button>
                </div>
            }
        </div>
        <div class="row mb-3" *ngIf="showRemarksField$ | async">
            <div class="col">
                <pace-forms-input-text
                    [id]="datePerformed.remarksXmlId"
                    [label]="datePerformed.remarksLabel"
                    [formControl]="remarksControl"
                ></pace-forms-input-text>
            </div>
        </div>
    </ng-container>
</fieldset>
